// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import VatSummaryResourceViewModel from '../../../../viewModel/resource/VatSummaryResourceViewModel';
import VatSummaryResourceDTO from '../../dto/resource/VatSummaryResourceDTO';

export default abstract class VatSummaryResourceModel extends BaseModel<VatSummaryResourceDTO> {
  /**
  * @type {double}
  */
  get vatRate() { return this.dto.vatRate; }
  set vatRate(value) { this.dto.vatRate = value; }
  /**
  * @type {double}
  */
  get vatAmount() { return this.dto.vatAmount; }
  set vatAmount(value) { this.dto.vatAmount = value; }
  /**
  * @type {double}
  */
  get netAmount() { return this.dto.netAmount; }
  set netAmount(value) { this.dto.netAmount = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.vatrate);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.vatRate = value;
    value = Number.parseFloat(qs.vatamount);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.vatAmount = value;
    value = Number.parseFloat(qs.netamount);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.netAmount = value;
  }
}
